import raw from "./design-tokens.json";

export type DesignTokens = typeof raw;
export type ThemeName = "light" | "dark";
export type ModeTokens = typeof raw.modes.light;
export type BrandTokens = typeof raw.brand;
export interface LevelTokens {
  outline: number;
  panelShadow: number;
  buttonShadow: number;
  edge?: number;
}

export const designTokens: DesignTokens = raw;
